import { render } from "./BaseLoadingSpinner.vue?vue&type=template&id=479a71b5&scoped=true"
import script from "./BaseLoadingSpinner.vue?vue&type=script&lang=js"
export * from "./BaseLoadingSpinner.vue?vue&type=script&lang=js"

import "./BaseLoadingSpinner.vue?vue&type=style&index=0&id=479a71b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479a71b5"]])

export default __exports__